import Typography from '@mui/material/Typography';
import styled from 'styled-components';

export const StyledError = styled(Typography)`
  color: ${props => props.theme.palette.error.main};
  font-weight: 500;
  position: relative;
  animation: fadeIn 1s ease;  

  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateX(-10px);
    }
    100% {
      opacity: 1;
      transform: translateX(0px);
    }
  }
`;
